var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.57186 4.40631C3.55044 4.40631 4.34374 3.57159 4.34374 2.5419C4.34374 1.51222 3.55044 0.67749 2.57186 0.67749C1.59328 0.67749 0.799988 1.51222 0.799988 2.5419C0.799988 3.57159 1.59328 4.40631 2.57186 4.40631Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.04843 5.64917H1.0953C0.932288 5.64917 0.799988 5.78838 0.799988 5.95991V15.282C0.799988 15.4535 0.932288 15.5927 1.0953 15.5927H4.04843C4.21144 15.5927 4.34374 15.4535 4.34374 15.282V5.95991C4.34374 5.78838 4.21144 5.64917 4.04843 5.64917Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.847 5.22115C11.5848 4.76623 10.0061 5.16584 9.05929 5.88239C9.02681 5.74877 8.91105 5.64934 8.77343 5.64934H5.82031C5.65729 5.64934 5.52499 5.78855 5.52499 5.96007V15.2821C5.52499 15.4537 5.65729 15.5929 5.82031 15.5929H8.77343C8.93644 15.5929 9.06874 15.4537 9.06874 15.2821V8.58268C9.54597 8.15014 10.1608 8.01217 10.664 8.23714C11.1519 8.45403 11.4312 8.98353 11.4312 9.6889V15.2821C11.4312 15.4537 11.5635 15.5929 11.7266 15.5929H14.6797C14.8427 15.5929 14.975 15.4537 14.975 15.2821V9.06308C14.9413 6.50945 13.7996 5.5642 12.847 5.22115Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.04d39f59c0d5126f387d6fb31bca0755.svg";
export { ForwardRef as ReactComponent };